import React, { useCallback } from 'react';
import { styled } from '@linaria/react';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { RadioCard, RadioCardSize } from '@daedalus/atlas/RadioCard';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { RoomConfigType } from '@daedalus/core/src/room/types/RoomConfiguration';
interface Props {
  isOptimized: boolean;
  onChange: (value: boolean) => void;
  size?: RadioCardSize;
  onSelectionClick?: (selectedOption: RoomConfigType) => void;
}
const _exp = /*#__PURE__*/() => Grid;
const RadioCardsWrapper = /*#__PURE__*/styled(_exp())({
  name: "RadioCardsWrapper",
  class: "rwt93kb",
  propsAsIs: true
});
const _exp2 = /*#__PURE__*/() => Grid;
const CardWrapper = /*#__PURE__*/styled(_exp2())({
  name: "CardWrapper",
  class: "c1mguea",
  propsAsIs: true
});
export const RoomConfigSelector = ({
  isOptimized,
  onChange,
  size,
  onSelectionClick
}: Props) => {
  const handleOptimizeRadioCardChange = useCallback(() => {
    onChange(true);
    onSelectionClick?.(RoomConfigType.Optimized);
  }, [onChange, onSelectionClick]);
  const handleManualRadioCardChange = useCallback(() => {
    onChange(false);
    onSelectionClick?.(RoomConfigType.Manual);
  }, [onChange, onSelectionClick]);
  return <RadioCardsWrapper container wrap="no-wrap" spacing="s300">
      <CardWrapper mobileSm="6">
        <RadioCard checked={isOptimized} onChange={handleOptimizeRadioCardChange} size={size}>
          <FormattedMessageWrapper dataId="optimizeForBestPrice" id="optimizeForBestPrice" defaultMessage="Optimize for best price" />
        </RadioCard>
      </CardWrapper>
      <CardWrapper mobileSm="6">
        <RadioCard checked={!isOptimized} onChange={handleManualRadioCardChange} size={size}>
          <FormattedMessageWrapper dataId="configureRoomsManually" id="configureRoomsManually" defaultMessage="Configure rooms manually" />
        </RadioCard>
      </CardWrapper>
    </RadioCardsWrapper>;
};

require("./RoomConfigSelector.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomConfigSelector.tsx");